import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import columns from "../../../../columns/ib/ibDashboard/IBClosedTrades";
import TableWithSkeleton from "../../../../components/table/TableWithSkeleton";
import { GetClosedTradesApi } from "../../../../api/request/ib/ibDashboard";
import MyPagination from "../../../../components/pagination/Pagination";
import { handleApiError } from "../../../../utils/handleApiError";

const ClosedTrades = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const getClosedTrades = async () => {
    setIsLoading(true);
    try {
      const params = { pageNumber, pageSize, applyPagination: true };
      const { data } = await GetClosedTradesApi(params);
      if (data?.success) {
        setData(data?.data);
        setTotal(data?.totalRecords);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getClosedTrades();
  }, [pageNumber, pageSize]);

  return (
    <>
      <TableWithSkeleton columns={columns} data={data} loading={isLoading} />

      <MyPagination
        total={total}
        page={pageNumber}
        setPage={setPageNumber}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default ClosedTrades;
